import { withForm } from "~/components/form/app-form";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const ChallengesSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Challenges / Struggles</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.AppField name="strugglesImageUrl">
            {(field) => (
              <field.ImageField
                purpose="offer"
                label="Image shown on the left side"
                recommendedDimensions={{ width: 440, height: 660 }}
              />
            )}
          </form.AppField>

          <form.AppField name="strugglesHeadline">
            {(field) => <field.TextField label="Headline" />}
          </form.AppField>

          <form.AppField name="strugglesDescription">
            {(field) => (
              <field.TextareaField label="Main Text" maxLength={500} />
            )}
          </form.AppField>
        </CardContent>
      </Card>
    );
  },
});
